module.exports = __webpack_public_path__ + "img/close.d0b210b1.svg";